import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { LegacyGuardControlProvider, LegacySirenControlProvider } from './legacy';
import { GuardControlContent } from './types';
export const GuardControlsProvider = memo(function GuardControlProvider(props) {
    const { children, guard_controls_config } = props;
    const { control_type } = guard_controls_config;
    const Provider = useMemo(() => control_type === 'guard'
        ? LegacyGuardControlProvider
        : LegacySirenControlProvider, [control_type]);
    return (_jsx(Provider, { guard_controls_config: guard_controls_config, children: children }));
});
export const useGuardControls = () => useContext(GuardControlContent);
